import type { ReactNode, MouseEvent } from 'react';
import s from './Button.module.scss';

// ── 공통 버튼(재사용 원본 1개 + variant) ─────────────────────────────
//   배경/근거: 목업 pill(시안) 버튼이 Spotlight·Instruments·Services·Products 4개 섹션에
//   .cta 로 "바이트 단위 동일" 복붙돼 있었음(2026-07-31 실측) → 원본 1개로 추출.
//   ★설계 결정: 정체성마다 컴포넌트를 "복제"하지 않고 variant prop 으로 파라미터화(재중복 방지).
//   ★className 병합: 섹션별 추가 효과(예: Products 활성 슬라이드 진입 애니메이션 .cta)를 덧입히기 위함.
//     → Button 이 className 을 root 로 전달하므로 섹션 모듈의 .cta(진입 애니)가 그대로 적용됨.
//   변경 금지 트리거: pill 기본 치수(16px/300/pad 16·40/radius 35)는 목업 실측값 — 바꾸면 4섹션 동시 영향.
type Variant = 'pill';

type Props = {
  children: ReactNode;
  variant?: Variant;
  href?: string;                       // 있으면 <a>, 없으면 <button> 렌더
  className?: string;
  onClick?: (e: MouseEvent) => void;
  ariaLabel?: string;
};

export default function Button({ children, variant = 'pill', href, className, onClick, ariaLabel }: Props) {
  const cls = [s.btn, s[variant], className].filter(Boolean).join(' ');
  if (href !== undefined) {
    return (
      <a href={href} className={cls} onClick={onClick} aria-label={ariaLabel}>{children}</a>
    );
  }
  return (
    <button type="button" className={cls} onClick={onClick} aria-label={ariaLabel}>{children}</button>
  );
}
